import React, { useState } from 'react';
import { AlertTriangle, FilePlus2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

// Alerta doctrinal: new rulings that contradict the doctrine this matter relies on
export const MatterDoctrineAlerts = ({ matter, onUpdated }) => {
  const { api } = useAuth();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const unread = matter.doctrine_alerts_unread || 0;
  if (!('doctrine_alerts_unread' in matter)) return null;
  const insert = async (a) => {
    try {
      await api.post(`/doctrine/alerts/${a.id}/insert`);
      setItems((xs) => xs.map((x) => (x.id === a.id ? { ...x, inserted: true } : x)));
      toast.success('Párrafo insertado en el último escrito de la causa'); onUpdated();
    } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo insertar'); }
  };
  const open = async () => {
    if (items) { setItems(null); return; }
    setBusy(true);
    try {
      const r = await api.get(`/doctrine/matters/${matter.id}/alerts`);
      setItems(r.data.alerts);
      if (unread) { await api.post(`/doctrine/matters/${matter.id}/alerts/read`); onUpdated(); }
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-2">
      <button data-testid={`matter-doctrine-alerts-btn-${matter.id}`} onClick={open} className={`flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs ${unread ? 'border-rose-500/60 bg-rose-500/10 text-rose-200' : 'border-slate-700 text-slate-400 hover:text-white'}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <AlertTriangle className="h-3 w-3" />}
        {unread ? `${unread} fallo(s) nuevo(s) contradicen tu doctrina` : 'Historial de alertas doctrinales'}
      </button>
      {items && (
        <div data-testid={`matter-doctrine-alerts-${matter.id}`} className="mt-2 space-y-2">
          {!items.length && <p className="text-xs text-slate-500">Sin alertas doctrinales.</p>}
          {items.map((a) => (
            <div key={a.id} data-testid={`doctrine-alert-${a.id}`} className="rounded-xl border border-rose-500/30 bg-rose-500/5 p-3 text-xs">
              <p className="font-semibold text-white">{a.tribunal || 'Tribunal s/i'} · {a.rol}{a.fecha ? ` · ${a.fecha}` : ''}</p>
              <p className="mt-0.5 text-slate-400">{a.tema} · {(a.autores || []).join(', ')} · {new Date(a.created_at).toLocaleDateString('es-CL')}{a.emailed ? ' · avisado por correo' : a.emailed === false ? ' · correo no enviado' : ''}</p>
              <p className="mt-1 text-rose-200">{a.explicacion}</p>
              {a.que_hacer && <p className="mt-1 text-slate-300"><b>Qué hacer:</b> {a.que_hacer}</p>}
              {a.parrafo && (
                <div className="mt-2 rounded-lg border border-slate-700 bg-slate-950/60 p-2">
                  <p className="text-[11px] font-semibold text-slate-400">Párrafo para neutralizar el fallo</p>
                  <p data-testid={`doctrine-alert-paragraph-${a.id}`} className="mt-1 font-serif text-slate-200">{a.parrafo}</p>
                  <button data-testid={`doctrine-alert-insert-${a.id}`} onClick={() => insert(a)} className="mt-2 flex items-center gap-1 rounded-full border border-amber-500/60 px-2 py-0.5 text-[11px] text-amber-200 hover:bg-amber-500/10">
                    <FilePlus2 className="h-3 w-3" />{a.inserted ? 'Insertado · volver a insertar' : 'Insertar en el último escrito'}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
